// eslint-disable-next-line import/prefer-default-export
export const PAGE_TITLE = 'MVPR';
export const PAGE_TITLE_SUFFIX = `| ${PAGE_TITLE}`;
